import { jsx as _jsx } from "react/jsx-runtime";
import isValidI18nKey from 'I18n/utils/isValidI18nKey';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import { AnimatedMessaging } from '../animation/MessagingAnimations';
import { useOnImageLoaded } from '../images/useOnImageLoaded';
import { BaseMessageCaption } from './BaseMessageCaption';
import { getMessage } from './MESSAGE';
import CheckedListItem from './CheckedListItem';
import { StyledIllustration, StyledMessagingIllustration } from './Messaging.styles';
import { useIsFramedCentredStep } from '../hooks/useIsFramedCentredStep';
const MAXIMUM_LIST_LENGTH = 3;
const VALID_LIST_I18N_INDICES = Array.from(Array(MAXIMUM_LIST_LENGTH).keys()).map(index => index + 1);

const MessageIllustratedList = ({
  messageKey
}) => {
  const {
    illustrationName,
    height,
    isHTMLMessage = false,
    animationDelay,
    footerComponent: FooterComponent
  } = getMessage(messageKey);
  const {
    imageLoaded,
    handleImageLoaded
  } = useOnImageLoaded(illustrationName);
  const {
    isFramedCentredStep
  } = useIsFramedCentredStep();
  const listContent = VALID_LIST_I18N_INDICES.filter(i18nIndex => isValidI18nKey(`message.${messageKey}.listItem_${i18nIndex}`)).map((i18nIndex, index) => /*#__PURE__*/_jsx(CheckedListItem, {
    className: index === 0 || isHTMLMessage ? 'm-top-3' : undefined,
    children: isHTMLMessage ? /*#__PURE__*/_jsx(FormattedHTMLMessage, {
      message: `message.${messageKey}.listItem_${i18nIndex}`
    }) : /*#__PURE__*/_jsx(FormattedMessage, {
      message: `message.${messageKey}.listItem_${i18nIndex}`
    })
  }, i18nIndex));
  return /*#__PURE__*/_jsx(AnimatedMessaging, {
    delay: animationDelay,
    loaded: imageLoaded,
    children: /*#__PURE__*/_jsx(StyledIllustration, {
      isFramedCentredStep: isFramedCentredStep,
      messageKey: messageKey,
      children: /*#__PURE__*/_jsx(BaseMessageCaption, {
        content: /*#__PURE__*/_jsx("div", {
          className: "m-bottom-4",
          children: listContent
        }),
        footer: FooterComponent && /*#__PURE__*/_jsx(FooterComponent, {
          messageKey: messageKey
        }),
        headingLevel: "H3",
        messageKey: messageKey,
        textAlign: "start",
        children: /*#__PURE__*/_jsx(StyledMessagingIllustration, {
          height: height,
          name: illustrationName,
          onLoad: handleImageLoaded
        })
      })
    })
  });
};

export default MessageIllustratedList;